import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from '@app/app-routing.module';
import { AngularMaterialModule } from '@app/shared/angular-material.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { PaymentResultComponent } from './payment-result/payment-result.component';

@NgModule({
	declarations: [
		PaymentResultComponent
	],
	imports: [
		AngularMaterialModule,
		AppRoutingModule,
		CommonModule,
		SharedModule,
		TranslateModule
	]
})
export class PaymentResultModule { }
